document.addEventListener("DOMContentLoaded", function () {

  const logoCarousel = document.querySelector(".logoCarousel");

  if (logoCarousel) {
    const logoCarouselGlide = document.querySelector(".logoCarousel__glide");
    let totalSlides = 0;

    if (logoCarouselGlide) {

      const lcGlide = new Glide(logoCarouselGlide, {
        type: 'carousel',
        autoplay: 1500,
        perView: 10,
        startAt: 0,
        focusAt: 0,
        keyboard: false,
        hoverpause: true,
        bound: true,
        gap: 30,
        breakpoints: {
          576: {
            perView: 3
          },
          768: {
            perView: 4
          },
          1024: {
            perView: 6
          },
          1440: {
            perView: 8
          }
        }
      });

      lcGlide.mount();

    }
  }
});
